<template lang="pug">
fieldset(:disabled="isLoading")
    update-cell-form(v-if="canManageOrderLayout" v-show="hasSelectedGrid")
    action-pages-panel
    action-details-panel
    action-groups-panel(@group_display="onGroupDisplayList")
</template>

<script>
import { OrderLayoutEvent } from './order-layout-bus';
import { mapGetters, mapActions } from 'vuex';
import actionDetailsPanel from './action/action-details';
import actionGroupsPanel from './action/action-groups';
import actionPagesPanel from './action/action-pages';
import updateCellForm from './order-layout-update-cell.vue';
import LoadingMixin from './mixins/loading';
import PermissionMixin from './order-layout-permission';

export default {
    components: {
        actionDetailsPanel,
        actionPagesPanel,
        actionGroupsPanel,
        updateCellForm,
    },

    mixins: [PermissionMixin, LoadingMixin],

    computed: {
        ...mapGetters('orderLayout', ['hasSelectedGrid']),
    },

    methods: {
        ...mapActions('orderLayout', ['getGroupList']),

        onGroupDisplayList(options) {
            this.getGroupList(options);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-action-menu.vue